import 'bootstrap-datepicker';
import moment from 'moment-timezone';


export default function (context) {
    if (context === document) {
        const dfpn = $.fn.datepicker;
        if (dfpn.dates[document.documentElement.lang] || null) {
            $.fn.datepicker.defaults.language = document.documentElement.lang;
        }
    }

    $('.input-group-datetime', context).each(function() {
        const widget = $(this);
        const dateField = widget.find('.date-picker');
        const timeField = widget.find('.time-picker');
        const clearButton = widget.find('.clear-date');
        const datepicker = dateField.datepicker({
            assumeNearbyYear: true,
            format: {
                toDisplay: function (date, format, language) {
                    return moment.tz(date, 'UTC').format(dateField.data('input-format'));
                },
                toValue: function (date, format, language) {
                    return moment.tz(date, dateField.data('input-format'), 'UTC')
                        // prevent date change because of client tz differences.
                        .hours(12)
                        .toDate()
                }
            }
        });
        let isFirst = true;
        const updateField = function(e) {
            const name = dateField.data('target-name');
            const target = widget.find('#' + name);
            if (datepicker.datepicker('getDate')) {
                const targetDate = moment(datepicker.datepicker('getDate'));
                if (timeField) {
                    let time = moment(timeField.val(), timeField.data('format'));
                    targetDate.hours(time.hour());
                    targetDate.minutes(time.minutes());
                    targetDate.seconds(0);
                }
                target.val(targetDate.format(dateField.data('value-format'))).trigger('change');
            } else {
                target.val('').trigger('change');
            }
            if (!isFirst && e && e.viewMode > 0) {
                datepicker.datepicker('setViewMode', e.viewMode - 1);
            } else if (e && e.viewMode === 0) {
                datepicker.datepicker('hide');
            }
            isFirst = false;
        }
        if (dateField) {
            datepicker.on('changeDate', updateField).on('blur', updateField);
            const currentDate = datepicker.datepicker('getDate');
            datepicker.datepicker('setDate', currentDate);

        }
        if (timeField) {
            timeField.on('change', updateField);
        }
        clearButton.on('click', function () {
            datepicker.datepicker('clearDates');
        });
    }).on('changeDate', function(e) {
        const $this = $(e.target)
        if (e && e.viewMode > 0) {
            $this.datepicker('setViewMode', e.viewMode - 1);
        } else if (e && e.viewMode === 0) {
            $this.datepicker('hide');
        }
    });
}
